<template>
  <div class="container">
    <div class="title">
      <p class="words">用电量(度)</p>
    </div>
    <div class="val-pot">用电量：{{carouselVal}}度</div>
    <div id="chart" ref="main" style="width: 100%; height: 160px"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      echartArea7: null,
      xData:[],
      yData:[],
      carouselVal:0,
      timerId: null, //定时器的标识
      timer:null
    };
  },
  props:{
    regionId:''
  },
  mounted() {
    this.initChart();
  },
  created() {
    this.timer = setInterval(() => {
      // setTimeout(this.getoption7Data(), 0);
    }, 1000 * 60);
  },
  destroyed() {
    clearInterval(this.timerId);
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    initChart() {
      this.echartArea7 = this.$echarts.init(this.$refs.main);
      this.getoption7Data()
    },
    // 组件7数据源 用电量
    getoption7Data() {
      this.$http({
        url: this.$http.adornUrl("/admin/api/realTime/getElectricityTotal"),
        method: "get",
        params: this.$http.adornParams({
          findType: 0,
          regionId: this.regionId,
        }),
      }).then(({ data }) => {
        console.log(data,'用电量')
        if (data.code == 0) {
          this.xData = data.data.keys;
          this.yData = data.data.values1;
          this.updatedChart();
        }
      });
    },
    updatedChart() {
      var XData = this.xData;
      var YData = this.yData
      const option = {
        grid: {
          left: "1%",
          right: "1%",
          bottom: "10%",
          top: "7%",
          height: "85%",
          containLabel: true,
          z: 22,
        },
        xAxis: {
          type: "category",
          gridIndex: 0,
          data: XData,
          axisTick: {
            show:true,
          },
          axisLine: {
            show:true,
            lineStyle: {
              color: "#fff",
            },
          },
          axisLabel: {
            show: true,
            color: "#fff",
            fontSize: 10,
          },
        },
        yAxis: {
          name:'元',
          type: "value",
          gridIndex: 0,
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          min: 0,
          max: function(value){
            if(value.max<=200000){
              return 200000
            }else if(value.max >200000 && value.max <=400000){
              return 400000
            }else{
              return 600000
            }
          },
          xisLabel: {
            color: "rgb(170,170,170)",
            formatter: "{value} ",
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
              color: "rgba(135,140,147,0.8)",
            },
          },
          axisLabel:{
            formatter:function(value){
              value = value.toString();
              if(value>=600000){
                return (value.substring(0,3)/10)+'万'
              }else if(value>=400000){
                return (value.substring(0,3)/10)+'万'
              }else if(value>=200000){
                return (value.substring(0,3)/10)+'万'
              }else if(value>=100000){
                return (value.substring(0,3)/10)+'万'
              }else{
                return 0
              }
            },
            fontSize: 10,
            textStyle:{
              color: "#fff",
            }
          },
          axisLine:{
            show:true,
            lineStyle: {
              color: "#fff",
            },
          }
        },
        series: [
          {
            name: "合格率",
            type: "bar",
            barWidth: "30%",
            itemStyle: {
              color: this.$echarts.graphic.LinearGradient(0,1,0,0,[
                {offset: 0, color: '#FFF8C8'},
                {offset: 1, color: '#F7B500'},
              ]),
              barBorderRadius:[10,10,0,0]
            },
            emphasis: {
              itemStyle: {
                color: "#FA6400",
              },
              label: {
                show: false,
              },
            },
            data: YData,
            zlevel: 11,
          },
        ],
      };

      this.echartArea7.setOption(option);
      let _t = -1;
      if (this.timerId) {
        clearInterval(this.timerId);
      }
      this.timerId = setInterval(() => {
        var dataLen = option.series[0].data.length;
        this.echartArea7.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: _t,
        });
        _t = (_t + 1) % dataLen;
        this.echartArea7.dispatchAction({
          type: "highlight",
          seriesIndex: 0,
          dataIndex: _t,
        });
        this.carouselVal = option.series[0].data[_t]
        // this.echartArea7.setOption(option);
      }, 1000);
    },
    // this.echartArea.setOption(option)
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding-top: 10px;
  position: relative;
  .val-pot{
    position: absolute;
    right: 20px;
    top: 12px;
    font-size: 12px;
  }
}
.title {
  width: 140px;
  height: 28px;
  line-height: 28px;
  background-image: url("../../assets/title-bg.png");
  background-size: 100% 100%;
  margin-bottom: 10px;
  margin-left: 10px;
  color: #00ecfc;
  position: relative;
  .words {
    position: absolute;
    left: 20px;
    top: 0px;
    width: 280px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/bicycle-system/option7.vue